module.exports = __webpack_public_path__ + "img/search.2978d387.svg";